import React from "react";
import { COLORS } from "@/app/common/consts/colors";
import type { IconProps } from "./type";

export default function CoinbaseOne({ color = "white" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6.00013 0C2.68579 0 0 2.69375 0 6.01747C0 9.12147 2.34435 11.6761 5.35424 12V7.41782C6.57831 6.90147 7.58078 5.96712 8.1873 4.79105V11.6126C10.4074 10.7298 12 8.559 12 6.01747C12 2.69375 9.31418 0 6.00013 0ZM2.57572 7.38947V4.64118C4.02434 4.64118 5.22333 3.58105 5.45025 2.19261H8.20819C7.96601 5.10181 5.53877 7.38947 2.57572 7.38947Z"
        fill={COLORS[color]}
      />
    </svg>
  );
}
